import { Button, IconButton, Modal } from '@shared/components';
import styles from '@features/CreateDatabaseModal/ui/CreateDatabaseModal.module.scss';
import { FC, useState } from 'react';
import CloseIcon from '@icons/CloseIcon/CloseIcon.tsx';
import DataBasesUploadForm from '@components/DataBasesUploadForm/DataBasesUploadForm.tsx';
import { addFilesToDatabase } from '@api/settings/apiService.ts';
import { useLoading } from '@providers/LoadingProvider/model/LoadingContext.ts';

interface IAddDatabaseFilesModalProps {
  showModal: boolean;
  onClose: () => void;
  onConfirm: () => void;
  id?: string;
  fetchDataBase: () => void;
  onFileUpload?: (file: File[]) => void;
}
const AddDatabaseFilesModal: FC<IAddDatabaseFilesModalProps> = (props) => {
  const { showModal, onClose, onConfirm, id, fetchDataBase } = props;
  const { setLoading } = useLoading();
  const [localFiles, setLocalFiles] = useState<File[]>([]);
  const onSubmit = () => {
    setLoading(true);
    onConfirm();
    if (props.onFileUpload) {
      props.onFileUpload(localFiles);
    } else {
      const formData = new FormData();
      formData.append('id', id!);
      localFiles.forEach((file) => {
        formData.append(`file`, file);
      });
      addFilesToDatabase(formData, () => {
        fetchDataBase();
        setLoading(false);
      });
      setLocalFiles([]);
    }
    setLocalFiles([]);
  };

  const handleClose = () => {
    setLocalFiles([]);
    onClose();
  };

  return (
    <Modal showModal={showModal}>
      <div className={styles.layout}>
        <div className={styles.uploadTitleBox}>
          <h3>Upload files from your computer</h3>
          <IconButton onClick={onClose} variant="text">
            <CloseIcon stroke="#667085" />
          </IconButton>
        </div>
        <DataBasesUploadForm files={localFiles} setFiles={setLocalFiles} />
        <div className={styles.buttonBlock}>
          <Button
            className={styles.cancelCreation}
            variant="active"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className={styles.createDatabase}
            variant="active"
            onClick={onSubmit}
            disabled={localFiles.length === 0}
          >
            Add files
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AddDatabaseFilesModal;
